<template>
  <el-card :body-style="{ padding: '0px' }">
      <div slot="header" class="record header">
            <img :src="require('./image/record-header.png')" class="header-icon" />
            <span class="header-title">
                Records
            </span>
            <span class="send-link" @click="addNew = true" v-if="getUserType !== 'observer'">
                <span>
                    <i>&#43;</i>
                    Add New
                </span>
            </span>
        </div>
        <RecordTable :patient="patient" @add-new="addNew = true"></RecordTable>
        <el-dialog
          :visible.sync="addNew"
          :append-to-body="true"
          :close-on-click-modal="false"
          class="send-now-modal"
          @close="closeNewFile"
          v-if="addNew"
          width="65%">
          <div slot="title">
              Add new Record
          </div>
          <div>
              <div class="input-row">
                  <label for="upload-file-name">Enter Record Name</label>
                  <input id="upload-file-name" v-model="recordName" type="text"
                    placeholder="e.g. Temperature recording" />
                    <span class="error-text" v-if="this.recordName == '' && this.showError">
                        Please enter a Record Name
                    </span>
              </div>
              <div class="input-row">
                  <label>Select Record Type</label>
                  <el-cascader
                    v-if="showMultiProviders"
                    class="category-cascader"
                    v-model="selectedProviderRecordType"
                    :options="multiProviderRecordCategories"
                    @change="handleCategoryChange"
                    size="small"
                    >
                  </el-cascader>
                  <el-select v-else size="mini" placeholder="Select From here" v-model="recordType">
                      <el-option
                          v-for="recordCategory in patientRecordCategories"
                          :key="recordCategory.id"
                          :label="recordCategory.title"
                          :value="recordCategory.id">
                        </el-option>
                  </el-select>

                  <span class="error-text" v-if="this.recordType == '' && this.showError">
                      Please select a Record Type
                  </span>
              </div>
              <div class="input-row full-width">
                    <label>Add Details</label>
                    <el-input
                        type="textarea"
                        :rows="5"
                        size="small"
                        :maxlength="5000"
                        placeholder="e.g. Temperature recording - 98.6 °F"
                        v-model="recordComment">
                    </el-input>
                    <div class="character-left">
                        {{ 5000 -  recordComment.length }} characters left
                    </div>
                    <span class="error-text" v-if="this.recordComment == '' && this.showError">
                      Please enter details
                  </span>
              </div>
              
          </div>
          <div class="footer">
              <LoadingButton
                    type="primary"
                    size="small"
                    class="send-button"
                    @click="addNewRecord"
                    :loading="creatingRecord"
                    :loaded="hasCreatedRecord">
                Done
            </LoadingButton>
            <el-button type="text" size="small" class="cancel-button" @click="addNew = false;closeNewFile()">
                Cancel
            </el-button>
          </div>
        </el-dialog>
  </el-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import OverviewCard from '..'
import RecordTable from './RecordTable'
import RecordHeader from './image/record-header.png'
import LoadingButton from '@/module/component/LoadingButton.vue'


export default {
    name: 'patient-record-card',
    extends: OverviewCard,

    data() {
        return {
            addNew: false,
            recordName: '',
            recordType: '',
            recordComment: '',
            creatingRecord: false,
            hasCreatedRecord: false,
            showError: false,
            selectedProviderRecordType: [],
            selectedProvider: null,
            selectedProfile: null
        }
    },

    computed: {
        ...mapGetters('provider', [
            'getPatientProviderProfileList',
            'getProviderNameById'
        ]),
        ...mapGetters('content', [
            'getProfileContent'
        ]),
        ...mapGetters(['getUserType']),
        patientProviderProfileList() {
            return this.getPatientProviderProfileList(this.patient.id)
        },
        patientRecordCategories() {
            if(this.patientProviderProfileList && this.patientProviderProfileList.length == 1)
                return (this.getContentKey('profile', this.patientProviderProfileList[0].profile, 'record_categories') || [])
                    .sort((a, b) => a.title.localeCompare(b.title, 'en', {sensitivity: 'base'}))
            return []
        },
        multiProviderRecordCategories() {
            try {
                return this.patientProviderProfileList
                    .map(({provider, profile}) => {
                        const value = provider + ':' + profile,
                            label = `${this.getProviderNameById(provider)} (${this.getContentKey('profile', profile, 'title')})`
                        const children = this.getProfileContent(profile, 'record_categories')
                            .map(({ id, title }) => ({ value: id, label: title }))
                        return {
                            value,
                            label,
                            children
                        }
                    })
            } catch (error) {
                console.error('Problem Calculating multiProviderQuestionnaireList ', error)
                return []
            }
        }
    },

    methods: {
        ...mapActions('provider', [
            'createRecord'
        ]),
        closeNewFile() {
            this.recordName = ''
            this.recordType = ''
            this.recordComment = ''
            this.selectedProviderRecordType = []
            this.selectedProvider = null
            this.selectedProfile = null
            this.creatingRecord = false
            this.hasCreatedRecord = false
            this.showError = false
        },
        addNewRecord() {
            if(this.recordName == '' || this.recordType == '' || this.recordComment == '') {
                this.showError = true
                return
            }
            let profile, provider
            if(this.provider) {
                provider = this.provider.provider
                profile = this.patientProviderProfileList.find(({provider}) => provider === this.getProvider.provider ).profile
            }
            else {
                provider = this.selectedProvider ? this.selectedProvider  : this.patientProviderProfileList[0].provider
                profile = this.selectedProfile ? this.selectedProfile : this.patientProviderProfileList[0].profile
            }

            const recordObj = {
                name: this.recordName,
                category_id: this.recordType,
                comment: this.recordComment,
                profile
            }
            this.creatingRecord = true
            this.createRecord({
                patient: this.patient.id,
                recordObj,
                provider
            })
            .then((response) => {
                this.hasCreatedRecord = true
                this.creatingRecord = false
                this.addNew = false
                this.closeNewFile()
            })
            .catch((error) => {
                this.creatingRecord = false
            })
        },
        handleCategoryChange(categoryValue) {
            if(categoryValue && Array.isArray(categoryValue) && categoryValue.length == 2) {
                const [provider, profile] = categoryValue[0].split(':')
                this.recordType = categoryValue[1]
                this.selectedProvider = provider
                this.selectedProfile = profile
            }
        }
    },

    components: {
        RecordTable,
        LoadingButton
    }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
.send-now-modal{
    .input-row {
        max-width: 500px;
        input{
            padding-left: 10px;
        }
    }
}
.character-left {
    font-size: 12px;
    color: #999999;
    margin-top: 3px;
}

.input-row.full-width {
    max-width: 100%;
}
</style>

<style lang="css" scoped>
.el-card >>> .el-card__header {
    height: 25px;
}
.input-row .el-select >>> .el-input__inner{
    padding-left: 10px;
    font-size: 14px;
    font-weight: 600;
}
.input-row .el-select >>> .el-input__inner::placeholder {
    font-size: 12px;
    font-weight: 400;
    color: #999999;
}
.input-row .el-textarea >>> textarea {
    padding-left: 10px;
    font-weight: 600;
    font-size: 14px;
}
.input-row .el-textarea >>> textarea::placeholder{
    color: #999999;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
}
.input-row .el-select >>> .el-select__caret{
    color: #666666;
}
</style>